var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"navbar-brand",staticStyle:{"margin-top":"0"},attrs:{"to":"/"}},[_c('span',{staticClass:"brand-logo"},[_c('logo-img')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }